export default "__VITE_ASSET__CNNUG3xa__"